__webpack_require__.p = "/wp-content/themes/sxbeds-2024/";